import { withSacredImages } from "../utils/image-urls";

/** @type {Array<{id:string,name:string,beginner:Object,deep:Object,deity_ids?:string[]}>} */
const SADHANAS_RAW = [
  {
    id: "japa",
    name: "Japa (mantra repetition)",
    deity_ids: [],
    beginner: {
      purpose: "Steady repetition of mantra to purify mind and awaken devotion.",
      steps: ["Choose one mantra from guru or tradition", "Use mālā or fingers — 108 rounds", "Same time daily"],
      mantra: "Your chosen deity mantra — e.g. ॐ नमः शिवाय",
    },
    deep: {
      breathing: ["Natural breath; sync with mantra if instructed"],
      mudras: ["Jñāna mudrā on lap", "Mālā in right hand for many traditions"],
      duration: ["11–108 minutes daily", "40-day vow common"],
      precautions: ["Pronunciation from teacher", "Don't multiply mantras without guidance"],
      scriptural_refs: ["Yoga Sūtra on japa", "Bhakti traditions"],
    },
  },
  {
    id: "pranayama",
    name: "Prāṇāyāma",
    deity_ids: [],
    beginner: {
      purpose: "Regulate breath to steady prāṇa and prepare meditation.",
      steps: ["Sit upright", "Nāḍī śodhana 5 rounds if trained", "End with silent sitting"],
      mantra: "So-ham awareness optional",
    },
    deep: {
      breathing: ["Nāḍī śodhana", "Ujjāyī in yoga class", "Bhastrika only with teacher"],
      mudras: ["Viṣṇu mudrā for alternate nostril"],
      duration: ["10–20 minutes before dhyāna"],
      precautions: ["Avoid forceful retention with heart issues", "Not during fever"],
      scriptural_refs: ["Haṭha Yoga Pradīpikā", "Patañjali Yoga Sūtra II.49–53"],
    },
  },
  {
    id: "trataka",
    name: "Trāṭaka",
    deity_ids: [],
    beginner: {
      purpose: "Gaze practice to build concentration.",
      steps: ["Gaze at flame or dot without blinking until tears", "Close eyes, visualize", "3–5 minutes"],
      mantra: "None required — optional Śiva or Devī dhyāna",
    },
    deep: {
      breathing: ["Slow ujjāyī optional"],
      mudras: ["Hands on knees"],
      duration: ["5–10 minutes daily max for beginners"],
      precautions: ["Stop if headache", "Not for severe eye conditions"],
      scriptural_refs: ["Haṭha Yoga Pradīpikā"],
    },
  },
  {
    id: "gayatri_sadhana",
    name: "Gāyatrī sādhana",
    deity_ids: ["saraswati"],
    beginner: {
      purpose: "Invoke solar wisdom through Gāyatrī mantra.",
      steps: ["Sandhyā times: dawn/noon/dusk", "Cover head", "108 Gāyatrī with meaning reflection"],
      mantra: "ॐ भूर्भुवः स्वः तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात्",
    },
    deep: {
      breathing: ["Prāṇāyāma before japa in tradition"],
      mudras: ["Upanayana holders: specific saṃdhyā gestures"],
      duration: ["Three sandhyās or minimum dawn"],
      precautions: ["Requires upanayana in strict śrauta; many householder adaptations exist — follow lineage"],
      scriptural_refs: ["Rig Veda 3.62.10", "Manu on sandhyā"],
    },
  },
  {
    id: "shiva_panchakshari",
    name: "Śiva Pañcākṣarī sādhana",
    deity_ids: ["shiva"],
    beginner: {
      purpose: "Five-syllable mantra for Śiva bhakti and fearlessness.",
      steps: ["Bathe or wash hands", "Offer water to liṅga or image", "Japa 108× with 'namaḥ' feeling"],
      mantra: "ॐ नमः शिवाय",
    },
    deep: {
      breathing: ["Inhale on Om, exhale on namaḥ śivāya — optional"],
      mudras: ["Abhaya for receiving grace"],
      duration: ["21 or 41 days", "Pradoṣa nights extended"],
      precautions: ["Sattvic food on vow days", "Avoid harsh speech"],
      scriptural_refs: ["Śiva Purāṇa", "Pañcākṣarī stotram"],
    },
  },
  {
    id: "hanuman_sadhana",
    name: "Hanumān sādhana",
    deity_ids: ["hanuman", "rama"],
    beginner: {
      purpose: "Strength, courage, and Rāma-bhakti through Hanumān.",
      steps: ["Tuesday/Saturday", "Chalisa or 11× mantra", "Offer sindūr with devotion"],
      mantra: "ॐ हनुमते नमः",
    },
    deep: {
      breathing: ["Strong exhale with rām syllable in some traditions"],
      mudras: ["Anjali during Chalisa"],
      duration: ["40 Saturdays for major sankalpa"],
      precautions: ["Brahmacharya often advised on vow", "Read Sundara Kāṇḍa weekly"],
      scriptural_refs: ["Rāmāyaṇa Sundara Kāṇḍa", "Hanuman Chalisa"],
    },
  },
];

export const SADHANAS = withSacredImages("sadhanas", SADHANAS_RAW);

export function getSadhana(id) {
  return SADHANAS.find((s) => s.id === id) ?? null;
}
